// Asal: Live-Suche im Kopf über Shopify search/suggest (Produkte mit Preis, Rezepte, Seiten). Ohne Bibliotheken.
(() => {
  const panel = document.querySelector('[data-asal-search]');
  const input = document.querySelector('.site-header__search-input');
  if (!panel || !input) return;
  const empty = panel.querySelector('[data-asal-search-empty]');
  const results = panel.querySelector('[data-asal-search-results]');
  const esc = s => String(s || '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const mark = (text, q) => {
    const t = String(text || '');
    const i = q ? t.toLowerCase().indexOf(q.toLowerCase()) : -1;
    return i < 0 ? esc(t) : esc(t.slice(0, i)) + '<mark>' + esc(t.slice(i, i + q.length)) + '</mark>' + esc(t.slice(i + q.length));
  };
  // Shopify-Bildadresse mit Breite (mit oder ohne vorhandene Parameter)
  const sized = (u, w) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '');
  const euro = v => Number(v).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  let timer = null;
  let last = '';

  const render = (q, data) => {
    const r = data.resources.results;
    const products = r.products || [];
    const articles = r.articles || [];
    const pages = r.pages || [];
    if (!products.length && !articles.length && !pages.length) {
      results.innerHTML = `<p class="asal-search__none">Keine Treffer für „${esc(q)}“. Probier es mit <button type="button" data-term="Orangen">Orangen</button> oder <button type="button" data-term="Zitronen">Zitronen</button>.</p>`;
      return;
    }
    let html = '<div class="asal-search__cols">';
    if (products.length) {
      html += '<div><p class="asal-search__label">Produkte</p><div class="asal-search__products">' + products.map(p => `
        <a class="asal-search__prod" href="${esc(p.url)}">
          <span class="asal-search__img">${p.featured_image && p.featured_image.url ? `<img src="${esc(sized(p.featured_image.url, 200))}" alt="" loading="lazy">` : ''}</span>
          <span class="asal-search__ptxt"><strong>${mark(p.title.split(' (')[0], q)}</strong><small>${Number(p.price_min) !== Number(p.price_max) ? 'ab ' : ''}${euro(p.price_min || p.price)}</small></span>
        </a>`).join('') + '</div></div>';
    }
    if (articles.length || pages.length) {
      html += '<div class="asal-search__side">';
      if (articles.length) html += '<p class="asal-search__label">Rezepte & Beiträge</p><ul>' + articles.map(a => `<li><a href="${esc(a.url)}">${a.image ? `<img src="${esc(sized(a.image, 96))}" alt="" loading="lazy">` : '<span class="asal-search__dot"></span>'}<span>${mark(a.title, q)}</span></a></li>`).join('') + '</ul>';
      if (pages.length) html += '<p class="asal-search__label">Seiten</p><ul>' + pages.map(p => `<li><a href="${esc(p.url)}"><span class="asal-search__dot"></span><span>${mark(p.title, q)}</span></a></li>`).join('') + '</ul>';
      html += '</div>';
    }
    html += `</div><p class="asal-search__all"><a href="/search?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last">Alle Ergebnisse für „${esc(q)}“ anzeigen →</a></p>`;
    results.innerHTML = html;
  };

  const search = async q => {
    last = q;
    if (q.length < 2) { results.hidden = true; empty.hidden = false; return; }
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,article,page&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,body`;
      const data = await fetch(url).then(r => r.json());
      if (q !== last) return;
      render(q, data);
      empty.hidden = true;
      results.hidden = false;
    } catch (e) { /* bei Fehlern bleibt die normale Suche über Enter */ }
  };

  input.setAttribute('autocomplete', 'off');
  input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(() => search(input.value.trim()), 180); });
  panel.addEventListener('click', e => {
    const b = e.target.closest('[data-term]');
    if (!b) return;
    input.value = b.dataset.term;
    input.focus();
    search(b.dataset.term);
  });
})();

// Fokus erst setzen, wenn das Suchfeld sichtbar ist (sonst gehen die ersten Tastendrücke verloren).
document.addEventListener('click', e => {
  if (!e.target.closest('.js-search-header, .js-search-head, [data-asal-search-open]')) return;
  let buf = '';
  const field = () => { const i = document.querySelector('.site-header__search-input, input[type="search"][name="q"]'); return i && i.offsetParent ? i : null; };
  const onKey = k => { if (k.key.length === 1 && !k.ctrlKey && !k.metaKey && document.activeElement !== field()) { buf += k.key; k.preventDefault(); } };
  document.addEventListener('keydown', onKey, true);
  const f = last => {
    const i = field();
    if (i && document.activeElement !== i) i.focus();
    if (i && buf) { i.value += buf; buf = ''; i.dispatchEvent(new Event('input', { bubbles: true })); }
    if (last) document.removeEventListener('keydown', onKey, true);
  };
  [30, 150, 300, 500].forEach((t, n, a) => setTimeout(() => f(n === a.length - 1), t));
}, true);
